import React from 'react';

import Icon from '../Icon/Icon';

const VivaceIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g strokeWidth='2' fill='none' fillRule='evenodd' strokeLinecap='round'>
                <g stroke='#34303D'>
                    <path d='m18.379 22.126 7.293-7.292M21.316 33.513l5.764-5.764' />
                </g>
                <g stroke='#272A33'>
                    <path d='M11.29 22.126 25.469 7.95M21.316 39.813 33.13 28M6.278 41.722 41.722 6.278' />
                </g>
            </g>
        </Icon>
    );
};

export default VivaceIcon;
